import API from "../utils/axiosUtils";


export const getAllBlogs = () => API.get('/blogs');
export const getSingleBlog = (id) => API.get(`/blog/${id}`);
export const createBlog = (data) => API.post('/blogs', data);
export const updateBlog = (id, data) => API.put(`/blogs/${id}`, data);
export const deleteBlog = (id) => API.delete(`/blogs/${id}`);
